export interface ActionType<T> {
  type: string;
  payload: T;
}

export function Action<T>(type: string, payload: T): ActionType<T> {
  return {type, payload};
}
